export const LEFT = 'left'
export const RIGHT = 'right'
export const PAGE_SIZE = 5
export const NO_DATA_TEXT =
  'You have not Trainings yet. It will appear here after your chatbot get first messages from users.'
